import { Component, HostBinding, Input, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core'
import { FormFieldComponent } from '../form-field/form-field.component'

@Component({
  selector: 'app-form-range',
  templateUrl: './form-range.component.html',
  styleUrls: ['../form-field-common.scss', './form-range.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormRangeComponent extends FormFieldComponent {
  @Input() max = 100
  @Input() min = 0
  @Input() step = 1

  @HostBinding('style')
  get rangeTheme() {
    return this.getRangeTrackStyle()
  }

  @ViewChild('slideInput') slideInput: ElementRef

  getRangeTrackStyle() {
    const value = this.ctrl.value || 0
    const slidedPercent = (value - this.min) / (this.max - this.min)
    return {
      '--track-background-image': `-webkit-gradient(linear, left top, right top, color-stop(${slidedPercent}, #29a2fa), color-stop(${slidedPercent}, #c5e1f9))`,
    }
  }
}
